<template>
    <span>Welcome to <b>Ascent</b></span>
</template>
<script>
  export default {
    name: 'notification-sample'
  }
</script>
<style>
</style>
